import { type LucySetupResult, setup } from '@stone-payments/lucy-chat-web'

import { type LucyChatConfig, type LucyFeatureFlags } from '../types'

import { createLucyAmplitudeAnalytics } from './lucy-amplitude-analytics'
import { createLucyDatadogLogger } from './lucy-datadog-logger'

import '@stone-payments/lucy-chat-web/styles.css'

let instance: LucySetupResult | null = null

export function initializeLucyChat(config: LucyChatConfig): void {
  if (typeof window === 'undefined') return
  if (instance) {
    instance.setUser(config.user)
    return
  }
  try {
    instance = setup({
      ...config,
      logger: config.logger ?? createLucyDatadogLogger(),
      analytics: config.analytics ?? createLucyAmplitudeAnalytics()
    })
  } catch (error) {
    console.error('[lucy-chat] failed to initialize', error)
  }
}

export function isLucyChatReady(): boolean {
  return instance !== null
}

export function openLucyChat(): void {
  instance?.controller.open()
}

export function closeLucyChat(): void {
  instance?.controller.close()
}

export function endLucyChatSession(): void {
  instance?.controller.endSession()
}

export function setLucyChatFlags(flags: Partial<LucyFeatureFlags>): void {
  instance?.setFlags(flags)
}

export function getLucyWidget(): LucySetupResult['LucyChatWidget'] | null {
  return instance?.LucyChatWidget ?? null
}
